export class PaymentHistory {
	accountNumber: string;
	contactName: string;
	paymentAmount: number;
	paymentDate: string;
	paymentResult: string;
	pnRef: string;
	transactionType: string;
	message: string;
	startDate: string;
}
